import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllDrivers = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/v2/drivers?limit=200',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveDriver = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/drivers',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateDriver = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/drivers/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteDriver = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/drivers/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllDrivers,
  saveDriver,
  deleteDriver,
  updateDriver,
}
